module.exports = __webpack_public_path__ + "img/eyes_female_average_makeup.233c252b.png";